import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "value"]

  connect() {
    this.sync()
  }

  sync() {
    const key = this.nameTarget.value.trim() || "Authorization"
    this.valueTarget.name = `webhook_subscription[headers][${key}]`
  }
}
